import { isDefined } from "@clipboard-health/util-ts";
import { isCapacitorPlatform, useAppInfo } from "@src/appV2/lib";
import { type ExternalTimekeepingIntegrationsConfig } from "@src/appV2/Shifts/Shift/ShiftState/types";
import { isEnabledForAppVersionAndOta } from "@src/appV2/Shifts/utils/isSolveUnpaidBreaksFeatureEnabled";

export function useIsTimekeepingIntegrationsEnabled(props: {
  config: ExternalTimekeepingIntegrationsConfig | undefined;
}): ExternalTimekeepingIntegrationsConfig | undefined {
  const { config } = props;
  const { appInfo } = useAppInfo();

  if (!isDefined(config)) {
    return undefined;
  }

  if (
    isCapacitorPlatform() &&
    appInfo &&
    !isEnabledForAppVersionAndOta({
      minimalOtaVersion: config.minimalOtaVersion.toString(),
      minimalStoreVersion: config.minimalStoreVersion,
      appInfo,
    })
  ) {
    return undefined;
  }

  return config;
}
